import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Services Syclus - Home'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'Services Syclus - Login'
    }
  },
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: () => import('../views/Usuarios.vue'),
    meta: {
      title: 'Services Syclus - Usuários'
    }
  },
  {
    path: '/aplicativos',
    name: 'Aplicativos',
    component: () => import('../views/Aplicativos.vue'),
    meta: {
      title: 'Services Syclus - Aplicativos'
    }
  },
  {
    path: '/tags',
    name: 'Tags',
    component: () => import('../views/Tags.vue'),
    meta: {
      title: 'Services Syclus - Tags'
    }
  },
  {
    path: '/recursos',
    name: 'Recursos',
    component: () => import('../views/Recursos.vue'),
    meta: {
      title: 'Services Syclus - Recursos'
    }
  },
  {
    path: '/tokens',
    name: 'Tokens',
    component: () => import('../views/Tokens.vue'),
    meta: {
      title: 'Services Syclus - Tokens'
    }
  },
  {
    path: '/licencas',
    name: 'Licencas',
    component: () => import('../views/Licencas.vue'),
    meta: {
      title: 'Services Syclus - Licenças'
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to acces a restricted page
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = store.getters.isLoggedIn;

  if (authRequired && !loggedIn) {
    return next('/login')
  } else if (to.path == '/login' && loggedIn) {
    return next('/')
  }

  document.title = to.meta.title
  next()
})

export default router
